import Axios from '../utils/axios-utils';


// clock in
export const clockIn = async (data, accountId) => {
    try {
        const response = await Axios.post(`/accounts/${accountId}/clock`, {
            latitude: data.latitude,
            longitude: data.longitude,
        });

        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Create clock error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Create clock failed" }
        };
    }
};

// clock out
export const clockOut = async (accountId, data) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/clock`, {
            latitude: data.latitude,
            longitude: data.longitude,
        });


        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update clock error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update clock failed" }
        };
    }
};

// get  Clock records
export const getClockRecords = async (accountId, from, to, userId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/clock`, {
            params: { from,to  },
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All clock error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All clock failed" }
        };
    }
};

// get  clock statuses
export const getClockStatus = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/clock/status`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All clock statuses error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All clock statuses failed" }
        };
    }
};


// get  Clock positioms
export const getClockPositions = async (accountId, clockId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/positions`, {
            params: { clockId },
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All clock positions error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All clock positions failed" }
        };
    }
};